import { TableColumn } from '@ui/aos-lib';
import { MeterTable } from 'src/app/services/data/devices-data/devices-data.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { deviceTypeTableIcon } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import {
  batteryStatusTooltip,
  deviceHealthTooltip,
  lastHeardTooltip,
  validReadRateTooltip
} from 'src/app/shared/components/listing-table/listing-page.consts';
import { BubbleColumnComponent } from 'src/app/shared/components/listing-table/components/bubble-column.component';
import { StatusDotColumnComponent } from 'src/app/shared/components/listing-table/components/status-dot-column.component';
import { LocationColumnComponent } from 'src/app/shared/components/table-columns/location-column.component';
import {
  CustomizableColumnComponent,
  CustomizableColumnType,
  CustomizableTableColumn,
  CustomizableTableColumnValue
} from '@portal/shared/components/listing-table/components/customizable-column.component';
import { CommDeviceIdColumnComponent } from '../../components/column/comm-device-id-column.component';
import { SerialNumberColumnComponent } from '../../components/column/serial-number-column.component';

export const createSensorsColumns = (): (TableColumn | CustomizableTableColumn)[] => [
  {
    field: 'commDeviceId',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.COMM_DEVICE_ID,
    width: 200,
    sortable: true,
    cmp: CommDeviceIdColumnComponent
  },
  {
    field: 'serialNumber',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.SERIAL_NUMBER,
    width: 200,
    sortable: true,
    cmp: SerialNumberColumnComponent
  },
  {
    field: 'deviceTypeName',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.DEVICE_TYPE,
    sortable: true,
    width: 250,
    icon: deviceTypeTableIcon
  },
  {
    field: 'gnnId',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.GNN_ID,
    sortable: true,
    width: 250,
    cmp: CustomizableColumnComponent,
    options: {
      columnType: CustomizableColumnType.TEXT,
      columnValues: (tableItem): CustomizableTableColumnValue[] =>
        (tableItem as unknown as MeterTable).servicePoints.map(servicePoint => ({
          text: servicePoint.serviceLocationId ?? ''
        }))
    }
  },
  {
    field: 'status',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.STATUS,
    width: 250,
    sortable: true,
    cmp: StatusDotColumnComponent,
    textColor: '#070C0F'
  },
  {
    field: 'deviceStatusValue',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.HEALTH,
    width: 300,
    sortable: true,
    cmp: BubbleColumnComponent,
    tooltip: deviceHealthTooltip
  },
  {
    field: 'lastHeard',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.LAST_HEARD,
    width: 300,
    sortable: true,
    tooltip: lastHeardTooltip
  },
  {
    field: 'batteryStatus',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.BATTERY_STATUS,
    width: 200,
    sortable: true,
    cmp: BubbleColumnComponent,
    tooltip: batteryStatusTooltip
  },
  {
    field: 'validTransmissionReadRateStatus',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.VALID_READ_RATE_STATUS,
    width: 200,
    sortable: true,
    cmp: BubbleColumnComponent,
    tooltip: validReadRateTooltip
  },
  {
    field: 'location',
    title: TranslateRegistry.get.SENSORS.VIEW_TABLE.LOCATION,
    width: 250,
    sortable: false,
    cmp: LocationColumnComponent
  }
];
